import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { signInWithRedirect, getCurrentUser, signOut, fetchAuthSession, signIn} from '@aws-amplify/auth';
import type { SignInOutput } from '@aws-amplify/auth';
import { LogService } from './log.service';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { AppAuth } from '../../models/appAuth';
import { SettingsService, StartupService, TokenService } from '../../core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Amplify } from 'aws-amplify';
import awsconfig from '../../../aws-exports';
import { hasValue } from '../../shared/common-functions';
import { environment } from '../../../environments/environment';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { sharedInMemoryStorage } from 'aws-amplify/utils';
//import { Console } from 'console';
import { UserContextPoolService } from '../../core/bootstrap/user-context-pool.service.';




const jwtHelper = new JwtHelperService();
interface TokenData {
    Id: any,
    unique_name: string,
    Email: string,
    UserRoleName: string,
}

interface UserData {
    Id: number;
    unique_name: string;
    LoginId?: string; 
    UserRoleName: string;
    token: string;
}
@Injectable({ providedIn: 'root' })
export class AuthService {

   
   private readonly apiURL = environment.apiRoot + 'client-apps/console/';
    idToken: string | undefined;
    accessToken: string | undefined;
    refreshToken: string | undefined;
    username: any;
    private readonly tokendata: TokenData;
    private readonly _appauth: AppAuth;
    private currentUserSubject: BehaviorSubject<AppAuth>;

     private readonly userPoolIDSubject = new BehaviorSubject<string>('');
       userPoolID$ = this.userPoolIDSubject.asObservable();
    constructor(
        private readonly router: Router,
        private readonly logService: LogService,
        private readonly settings: SettingsService,
        private readonly startup: StartupService,
        private readonly token: TokenService,     
         private readonly httpBackend: HttpBackend,
         private userContextPool:UserContextPoolService
    ) {
    
     }

     

    async loginWithAzureAD() {
        await signInWithRedirect({ provider: { custom: 'AzureAD' } });
    }

    async logout() {
        await signOut();
    }

    async getUser() {
        try {
            return await getCurrentUser();
        }
        catch (e: unknown) {
            console.error("An error occurred: ", e);
            return null;
        }
    }

    async fetchUserPool(){

     const userPoolID=this.userContextPool.getUserPoolId()? this.userContextPool.getUserPoolId(): sessionStorage.getItem("UserPoolID");
      const useRegion=this.userContextPool.getUserRegion()? this.userContextPool.getUserRegion(): sessionStorage.getItem("UserRegion");
       const amplifyConfigRaw=this.userContextPool.getamplifyConfig()? this.userContextPool.getamplifyConfig(): sessionStorage.getItem("AmplifyConfig");
     
      
      if(amplifyConfigRaw){
        
        const amplifyConfig = amplifyConfigRaw
                    ? JSON.parse(amplifyConfigRaw)
                  : null;
       
       await this.configureAmplifyConfig(amplifyConfig);
        
      }
   
     
      this.userContextPool.setUserPoolId(userPoolID);
       this.userContextPool.setUserRegion(useRegion);
       this.userContextPool.setamplifyConfig(amplifyConfigRaw)

       sessionStorage.removeItem("UserPoolID");
       sessionStorage.removeItem("UserRegion");
       sessionStorage.removeItem("AmplifyConfig");
    }
  
    async getUserTokens(fetchType:any="fetchingdata") {
        try {

          this.fetchUserPool();
         
            const session = await fetchAuthSession();
            if (session?.tokens) {
                this.idToken = session.tokens.idToken?.toString();               
                this.accessToken = session.tokens.accessToken?.toString();
                this.username = session.tokens.idToken?.payload.username || session.tokens.idToken?.payload['cognito:username'];

                const payload = session.tokens.idToken?.payload;
                if (payload) {
                    let userFullName: string;
                    if (typeof payload.name === 'string') {
                        userFullName = payload.name;
                    } else { userFullName = this.username; }
                    let userEmail: string;
                    if (typeof payload.email === 'string') {
                        userEmail = payload.email;
                    } else { userEmail = ''; }
                    const UserRoleNamefromtoken: any = session.tokens.idToken?.payload["deckorate:user_roles"]

                    const UserRoleName = UserRoleNamefromtoken[0].toString()

                    this.logService.setUserFullName(userFullName);
                    this.logService.setUserRoleName(UserRoleName);
                  
                    const userObj = {
                        Id: 0,
                        unique_name: userFullName,
                        UserRoleName: UserRoleName,
                        LoginId: userEmail,
                        RoleId: 0,
                        username: userFullName,
                        firstName: userFullName,
                        lastName: '',
                        userRoleName: UserRoleName,
                        token: this.idToken || '',
                        password: '',
                        userName: userFullName
                    };

                   if(UserRoleName==='' || UserRoleName==null){                   
                     this.router.navigate(['/auth']);
                   }

                   // sessionStorage.setItem("currentUserData", JSON.stringify(userObj));
                    this.setcurrentUser(userObj);
                    if(fetchType!=="fetchingdata"){
                    this.router.navigate(['/dashboard']);
                }
                    return userObj;
                }
            } else {
                console.log('No active session or tokens found.');
                this.router.navigate(['/auth']);
            }
        } catch (error) {
            console.error('Error fetching session or tokens:', error);
            this.router.navigateByUrl("/auth");
        }
    }

    setcurrentUser(userObj: any): void {
        this.currentUserSubject = userObj;
    }
   
    async isLoggedIn(): Promise<boolean> {
        try {
            await getCurrentUser();
            return true;
        } catch (e: unknown) {
            console.error("An error occurred: ", e);
            return false;
        }
    }

    //code for enterpriseLogin and UserName PAssword logiin 
     //username and password login 
    fetchDomain(username: string) {
      try{
        if (!username) return '';
        const parts = username.split('@');
        return parts.length > 1 ? parts[1] : '';
      }
      catch(error){return "Invalid username"}

      }

      async getAmplifyconfig_bydomain(domain: string): Promise<any> {
        const apiUrl = this.apiURL;
        const httpclient = new HttpClient(this.httpBackend);
        return await firstValueFrom(
          httpclient.get<any>(this.apiURL+"by-domain/"+domain)
        );
      }
   
      async getAmplifyconfig_byEnterpriseKey(enterprisekey: string): Promise<any> {
        const apiUrl = this.apiURL;
        const httpclient = new HttpClient(this.httpBackend);
        return await firstValueFrom(httpclient.get<any>(this.apiURL+"by-enterprise-key/"+enterprisekey));
      }

      async configureAmplifyConfig(config:any){
      const origin = window.location.origin;
      const cleanDomain = config.data.cognitoDomain.replace(/^https?:\/\//, '');

      //this.userpoolIdSubject.next(config.data.cognitoUserPoolId);
    sessionStorage.setItem("AmplifyConfig",JSON.stringify(config));
    sessionStorage.setItem("UserPoolID",config.data.cognitoUserPoolId);
    sessionStorage.setItem("UserRegion",config.data.cognitoRegion)

    

      Amplify.configure({
        Auth: {
          Cognito: {
            userPoolId: config.data.cognitoUserPoolId,
            userPoolClientId: config.data.cognitoClientId,
            //region: config.data.cognitoRegion,  // valid here
            loginWith: {
              oauth: {
                domain: cleanDomain,
                scopes: ['email', 'openid', 'profile'],
                redirectSignIn: [`${origin}/tokenverify`],
                redirectSignOut: [`${origin}/tokenverify`],
                responseType: 'code',
                providers: [config.data.cognitoIdps]   // AzureAD
              },
                username: true,
                email: true,
                phone: false,
            }
          }
        }
      });
    
      cognitoUserPoolsTokenProvider.setKeyValueStorage(sharedInMemoryStorage)
      }

   async loginWithUsernamePassword(username: string, password: string): Promise<any> {
  try {
    // Native login only: trim what the user typed, and lower-case it for the first Cognito attempt.
    const enteredUsername = (username ?? '').trim();
    const normalizedUsername = enteredUsername.toLowerCase();

    const domain=this.fetchDomain(normalizedUsername);
    if(domain && domain!='Invalid username'){

      const config = await this.getAmplifyconfig_bydomain(domain);
      await this.configureAmplifyConfig(config);
    const result = await this.signInWithUsernameCaseFallback(normalizedUsername, enteredUsername, password);

    // Handle MFA, NEW_PASSWORD_REQUIRED, etc.
    if (result.nextStep?.signInStep !== 'DONE') {
      return { challenge: result.nextStep };
    }

    return  await this._loadUserData();
  }

  else{return "Invalid Username"};
    // Signed in successfully
    
  }
  catch (er: any) {
    console.error('Username/Password Login Error:', er);
    throw er.error?er.error:er;
  }
}

  /**
   * Cognito native (username/password) sign-in that is tolerant of username casing.
   *
   * 1. Signs in with the trimmed, lower-cased username (`toLowerCase()` is the
   *    locale-independent equivalent of .NET `ToLowerInvariant()`).
   * 2. If that fails and the user typed the username with different casing, retries once
   *    with the username exactly as entered (trimmed).
   * 3. If the retry fails too, the normal authentication error from that attempt is thrown.
   *
   * Only the identifier sent to Cognito changes: no Cognito user is created or modified,
   * and the SSO flows (enterprise key / AzureAD redirect) do not go through this method.
   */
  private async signInWithUsernameCaseFallback(
    normalizedUsername: string,
    enteredUsername: string,
    password: string
  ): Promise<SignInOutput> {
    try {
      return await signIn({ username: normalizedUsername, password });
    } catch (lowerCaseAttemptError) {
      if (enteredUsername === normalizedUsername) {
        throw lowerCaseAttemptError;
      }
      return await signIn({ username: enteredUsername, password });
    }
  }



  //code for enterprisekey logiin
   async loginWithEnterpriseKey(enterprisekey: string): Promise<any> {
  try {
       const config = await this.getAmplifyconfig_byEnterpriseKey(enterprisekey);
      await this.configureAmplifyConfig(config); 
      const providername=await config.data.cognitoIdps
       await signInWithRedirect({ provider:  { custom: providername } }); 

  }
  catch (er: any) {
    console.error("Enterprise Key Login Error:", er);
    throw er.error?er.error:er;
  }
}

 private async _loadUserData(): Promise<void> {
        try {
            const data: UserData = await this.getUserTokens("Login");
           if (hasValue(data)) {

                const userId = data.Id;
                const userFullName = data.unique_name;
                const userEmail = data?.LoginId; // Using optional chaining for LoginId
               const UserRoleName = data.UserRoleName;
               const token = data.token;

                this.settings.setUser({
                    id: userId,
                    name: userFullName,
                    email: userEmail,
                    avatar: './assets/images/avatar.png',
                    role: data.UserRoleName,
                });

             this.token.set({ token: token, userId, userFullName, UserRoleName });
              
                await this.startup.load(); 
                this.logService.setUserFullName(userFullName);
               this.logService.setUserRoleName(UserRoleName);
               sessionStorage.removeItem('usr');
               sessionStorage.removeItem('jwt');
            }
        } catch (error) {
            console.error('Error loading user data:', error);
        }
    }
    //code end for enterpriseLogin and UsernamePassword
}